import { TecLoader } from "./TechLoader";
import { TecItemCreate } from "./TecItemCreate";
import { TweenMax } from "gsap";
import CarouselMv from "../utils/CarouselMv";
import model from "../../model/Model";

export class TechIndex {
    private $root = $('.m_moreBtn__wrap');
    private $navi = $('.m_radio').find('input');
    private $block = $('.m_photoBox li[data-category]');
    private $btn = $('.m_moreBtn');
    private $mainVisual = $('.visual__list');//変更無し
    private index = this.$block.length;
    private item: any = [];
    private select: string = '';
    private class_hide: string = 'technology__indexlist--hide';
    private class_old_hide: string = 'technology__old--hide';
    private class_active: string = 'technology__category--active';
    private class_is_old: string = 'is-old';
    private mode: string = 'clear';
    private all_msg = $('#technology__ai--text');
    private all_none = $('#technology__none--text');
    private moreLimit: number = 9;
    private isLinkClick = false;
    constructor() {
        // console.log('**TechIndex**');
        $("html,body").scrollTop(0);
        // this.$mainVisual.empty();
        this.$root.find('ul').empty();
        new TecLoader((data) => { this.onData(data) });
        // window.addEventListener('pageshow', () => {
        //     var perfEntries = performance.getEntriesByType("navigation");
        //     var type = null;

        //     perfEntries.forEach(function (pe: any) {
        //         // 読み込みタイプを取得
        //         type = pe.type;
        //     });

        //     // ブラウザバックかどうかの判定
        //     if (type == 'back_forward') {
        //         // 実行したい処理を記述
        //         console.log('ブラウザバック');

        //     }
        // });

        window.addEventListener('hashchange', () => {
            if(this.isLinkClick) return;
            // console.log('ハッシュチェンジ');
            this.triggerHashStart();
        }, false); {

        }

    }

    /**
     * データ取得完了。
     * 絞り込み用オブジェクト作成
     * @param {*} data
     * @memberof TechIndex
     */
    public onData(data): void {
        let i: number;
        let mv_src: string = '';
        // 表示要素生成
        var src: TecItemCreate = new TecItemCreate();
        var src_create = src.createItem(data);
        var src_create_mv = src_create.src_data;



        // サムネイル処理
        this.$root.find('ul').append(src_create.src_string)
        this.$block = $('.m_photoBox li[data-category]');
        this.$block.addClass('is-active');
        this.index = this.$block.length;
        for (i = 0; i < this.index; i++) {
            let block = this.$block.eq(i);
            if (i + 1 > this.moreLimit) {
                block.addClass(this.class_hide).addClass('sort-more');
            }

            this.item[i] = {
                root: block,
                tag: String(block.attr('data-category')).split(','),
                isOld: (block.attr('data-old') == 'true') ? true : false
            }

            if (this.item[i].isOld) {
                block.addClass(this.class_old_hide);
            }
        }

        this.init();
    }

    /**
     * UI、機能部分初期化
     * @private
     * @memberof TechIndex
     */
    private init(): void {
        // console.log('---init--');
        $("html,body").scrollTop(0);
        $('#technology__category--clear').show();
        this.$navi.on('change', (e) => this.onChange(e));
        this.$btn.on('click', (e) => this.onMore(e));
        this.$block.find('a').on('click', (e) => this.onLink(e))


        this.triggerHashStart();
        $(window).on('load', () => {
            console.log('--loaded--test');
            // this.triggerHashStart();
        });



        // this.all_btn.on('click', () => this.showAll());
        // this.all_btn.hide();
        // new CarouselMv($('.carousel--mv'));
    }

    private triggerHashStart() {
        console.log('---triggerHashStart');
        $('body').removeClass('css-loading');
        $('#loading').addClass('loaded');
        $("html,body").scrollTop(0);
        this.onHash();
    }


    private onHash() {
        let urlHash: any = location.hash.substring(1) as string;
        let isMoreOpen = false;
        let number = 0;
        let cat = '';
        // URLにアンカーが存在する場合
        if (urlHash) {
            if (urlHash.includes('_oepn')) {
                isMoreOpen = true;
                urlHash = urlHash.split('_oepn')[0];
            }
            cat = urlHash.split('_')[0];
            number = urlHash.split('_')[1];
            for (let i = 0; i < this.$navi.length; i++) {
                const $naviInput = this.$navi.eq(i);
                if ($naviInput.attr('data-sortcategory') === cat) {
                    $naviInput.prop('checked', true);
                    this.onSort($naviInput);
                }
            }
            if (isMoreOpen) {
                this.$btn.addClass('is_close is-close').text('閉じる');
                $('.sort-more').removeClass(this.class_hide);
            }
            // console.log('位置:', number);

            let $currentLi = $('.m_photoBox li.is-active').eq(number - 1);
            if($('.m_moreBtn__wrap').hasClass('is-old')) $currentLi = $('.m_photoBox li.technology__old--hide').eq(number - 1);
            this.onSetScroll($currentLi);
        }
    }

    private onSetScroll($target) {
        const $liOffset: any =$target.offset();
        let top = $liOffset.top as number;
        const topNum = top - Number($('.l_header').height());
        $('body,html').animate({ scrollTop: topNum }, 400, 'swing');
    }

    /**
     * 絞り込み処理
     * @private
     * @param {*} e
     * @memberof TechIndex
     */
    private onChange(e): void {
        let tag = $(e.currentTarget);
        this.onSort(tag);
    }

    private onSort($tag) {
        let tag = $tag;
        let select: any = tag.attr('data-sortcategory');
        let is_hit = 0;
        $('.m_moreBtn__wrap').removeClass('is_hide');
        this.$block.addClass(this.class_hide).removeClass('sort-more is-active');
        this.$navi.removeClass(this.class_active);
        this.$root.removeClass(this.class_is_old);
        this.all_none.hide();

        if (select === 'category-all') {
            // クリア
            this.$block.removeClass(this.class_hide);
            this.$block.addClass('is-active');
            is_hit = this.index;
            select = '';
            for (let i = 0; i < this.index; i++) {
                if (i + 1 > this.moreLimit) {
                    this.item[i].root.addClass('sort-more');
                    if (!this.$btn.hasClass('is-close')) {
                        this.item[i].root.addClass(this.class_hide);
                    }
                }
            }
            this.$btn.show();
            // this.all_btn.hide();
            this.messageView(this.all_msg, true);
        } else if (select === 'category-old') {
            let isCategory02: Boolean = false;
            this.$root.addClass(this.class_is_old);
            // 絞り込み:アーカイブ編
            for (let i = 0; i < this.index; i++) {
                if (this.item[i].isOld) {
                    this.item[i].root.removeClass(this.class_hide);
                    is_hit++;
                    if (is_hit > this.moreLimit) {
                        this.item[i].root.addClass('sort-more');
                        if (!this.$btn.hasClass('is-close')) {
                            this.item[i].root.addClass(this.class_hide);
                        }
                    }
                    if (this.item[i].tag.indexOf("category02") >= 0) {
                        isCategory02 = true;
                    }

                }
            }
            if (isCategory02) {
                this.messageView(this.all_msg, true);
            } else {
                this.all_msg.hide();
            }
            tag.addClass(this.class_active);
            // this.all_btn.show();
        } else {
            // 絞り込み
            for (let i = 0; i < this.index; i++) {
                if (this.isInArray(select, this.item[i].tag) && !this.item[i].isOld) {
                    // console.log(this.item[i].root);
                    this.item[i].root.removeClass(this.class_hide);
                    this.item[i].root.addClass('is-active');
                    is_hit++;
                    if (is_hit > this.moreLimit) {
                        this.item[i].root.addClass('sort-more');
                        if (!this.$btn.hasClass('is-close')) {
                            this.item[i].root.addClass(this.class_hide);
                        }
                    }
                }
            }

            //(AI・ディープラーニングのメッセージ)　#technology__ai--text
            if (select === 'category02') {
                this.messageView(this.all_msg, true);
            } else {
                this.all_msg.hide();
            }
            tag.addClass(this.class_active);

            // this.all_btn.show();
        }
        // console.log(is_hit+'/'+this.moreLimit);
        if (is_hit > this.moreLimit) {
            this.$btn.show();
            // $('.m_moreBtn__wrap').addClass('is_hide');
        } else {
            this.$btn.hide();
            // $('.m_moreBtn__wrap').removeClass('is_hide');
        }

        if (is_hit === 0) {
            this.messageView(this.all_none, true);
        }


        this.select = select;

        TweenMax.fromTo(this.$root, 0.4, { opacity: 0 }, { opacity: 1, delay: 0.15 })
        $('.technology__indexlist--title').css({ height: 'auto' });

    }

    /**
     * 全て見る処理（8件縛りなしで、もっと見るボタンもなし）
     * @private
     * @memberof TechIndex
     */
    private showAll(): void {
        this.select = '99';
        this.$navi.removeClass(this.class_active);
        this.$root.removeClass(this.class_is_old);
        // this.all_btn.hide();
        this.all_none.hide();
        this.messageView(this.all_msg, true);
        // this.$btn.hide();
        this.$block.removeClass(this.class_hide);
        TweenMax.fromTo(this.$root, 0.4, { opacity: 0 }, { opacity: 1, delay: 0.15 })
    }

    /**
     * もっと見る処理。9件目以降を表示
     * @private
     * @param {*} e
     * @memberof TechIndex
     */
    private onMore(e) {
        e.preventDefault();
        const $btn = $(e.currentTarget);
        const $moreBlock = $('.sort-more');
        const class_close = 'is-close';
        $('.m_moreBtn__wrap').removeClass('is_hide');
        if ($btn.hasClass(class_close)) {
            $btn.removeClass(class_close);
            $moreBlock.addClass(this.class_hide);
        } else {
            $btn.addClass(class_close);
            $moreBlock.removeClass(this.class_hide);
        }
        $(window).trigger('resize');
        return false;
    }

    private onLink(e) {
        e.preventDefault();
        this.isLinkClick = true;
        const $btn = $(e.currentTarget);
        const $li = $btn.parent();
        const target = $btn.attr('target');
        const link = $btn.attr('href');
        const sortCat = this.radioCat();
        let isMoreOpen = '';
        let number = $li.index('.is-active') + 1;
        if($('.m_moreBtn__wrap').hasClass('is-old')) number = $li.index('.technology__old--hide') + 1;
        if (this.$btn.hasClass('is-close')) isMoreOpen = '_oepn';
        window.location.hash = sortCat + '_' + number + isMoreOpen;
        if (target === '_blank') {
            window.open(link, '_blank');
        } else {
            $("html,body").scrollTop(0);
            window.open(link, '_self');
        }
        return false;
    }

    private radioCat() {
        let cat = '';
        for (let i = 0; i < this.$navi.length; i++) {
            if (this.$navi.eq(i).prop("checked")) {
                cat = this.$navi.eq(i).attr('data-sortcategory') as string;
            }
        }
        return cat;
    }


    private isInArray(arr1, arr2) {
        var res = false;
        for (var j = 0; j < arr2.length; j++) {
            if (arr1 === arr2[j]) {
                res = true;
                break;
            }
        }
        return res;
    }


    private messageView(target, is_view): void {
        if (is_view) {
            target.show();
            TweenMax.fromTo(target, 0.3, { opacity: 0 }, { opacity: 1, delay: 0.15 });
        }
    }

}